import React, { createContext, useCallback, useContext, useState } from 'react';
import { MenuItem } from '../shared/constants/menu';

interface IDrawerContextData {
    isDrawerOpen: boolean;
    toggleDrawerOpen: () => void;
    drawerOptions: MenuItem[];
    setDrawerOptions: (newDrawerOptions: MenuItem[]) =>void;
}


const DrawerContext = createContext({} as IDrawerContextData);

export const useDrawerContext = () => {
    return useContext(DrawerContext);
};

interface IAppDrawerProviderProps {
    children: React.ReactNode
}

export const DrawerProvider: React.FC<IAppDrawerProviderProps> = ({ children }) => {
    const [drawerOptions, setDrawerOptions] = useState<MenuItem[]>([]);
    const [isDrawerOpen, setIsDrawerOpen] = useState(true);
    
    const toggleDrawerOpen = useCallback(() => {
        setIsDrawerOpen(oldDrawerOpen => !oldDrawerOpen);
    }, []);

    const handleSetDraweOptions = useCallback((newDrawerOptions: MenuItem[]) => {
        setDrawerOptions(newDrawerOptions);
    }, []);

    return (
        <DrawerContext.Provider value={{ isDrawerOpen, drawerOptions, toggleDrawerOpen, setDrawerOptions: handleSetDraweOptions }}>
            {children}
        </DrawerContext.Provider>
    );
};
